export const NSIR_FILTER_LIKE_PREFIX = '__nsir_filter_like__:';

export const isLikeOption = (option) => Boolean(option && option.isLike);

export const buildLikeOption = (query, noun) => {
  const q = String(query ?? '').trim();
  return {
    value: `${NSIR_FILTER_LIKE_PREFIX}${q}`,
    label: `${noun} contém "${q}"`,
    isLike: true,
    likeQuery: q,
  };
};

/**
 * A linha "contém …" e as opções exatas não convivem.
 * A opção recém-marcada vence: novo contém substitui a seleção; uma opção exata tira o contém.
 */
export const resolveLikeSelection = (previous, selected) => {
  const prev = previous || [];
  const next = Array.isArray(selected) ? selected : [];
  const prevIds = new Set(prev.map((option) => option.value));
  const added = next.filter((option) => !prevIds.has(option.value));
  const addedLike = added.find(isLikeOption);

  if (addedLike) return [addedLike];
  if (added.some((option) => !isLikeOption(option))) {
    return next.filter((option) => !isLikeOption(option));
  }

  const likeOpt = next.find(isLikeOption);
  const real = next.filter((option) => !isLikeOption(option));
  if (likeOpt && real.length) return real;
  if (likeOpt) return [likeOpt];
  return real;
};
